// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dark .setup-header-nav button.secondary {
  background: var(--black1);
}

.setup-header {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  max-width: 1024px;
  margin: 0 auto;
}
.setup-header-container {
  height: 56px;
  flex: 0 0 56px;
  border-bottom: 0;
  width: 100%;
  z-index: 13;
  position: relative;
  background: var(--white);
  box-shadow: 0 2px 4px -1px rgba(7, 14, 35, 0.08);
}
.setup-header-container-mobile {
  display: none !important;
}
.setup-header-line {
  width: 740px;
  min-width: 70%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: var(--black5);
}
.setup-header-line div {
  display: flex;
  align-items: center;
  margin-right: 1.5rem;
  cursor: pointer;
}
.setup-header-line div:last-child {
  margin-right: 0;
}
.setup-header-line span {
  width: 2rem;
  height: 2rem;
  background: var(--black1);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease;
  cursor: pointer;
  border-radius: 100%;
  margin-right: 0.5rem;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: var(--black5);
}
.setup-header-line span.active {
  background: var(--purple0);
  color: var(--purple5);
}
.setup-header-line span.checked {
  background: var(--green0);
  color: var(--purple5);
}
.setup-header-logo {
  width: 132px;
  max-width: 15%;
  height: 100%;
  cursor: pointer;
  background: var(--white);
}
.setup-header-logo-image {
  width: 240px;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 0 0 1.5rem;
  justify-content: space-between;
}
.setup-header-logo-image-big {
  opacity: 1;
  transition: opacity 0.15s ease;
}
.setup-header-nav {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 132px;
  max-width: 15%;
  padding: 0 1.5rem 0 1rem;
}
.setup-header-menu {
  display: flex;
  align-items: center;
  transition: all 0.15s ease;
}

@media (max-width: 768px) {
  .setup-header {
    width: 100%;
  }
  .setup-header-container {
    height: auto;
  }
  .setup-header-container > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 3.5rem;
    flex: 0 0 3.5rem;
  }
  .setup-header-container-mobile {
    border-top: 1px solid var(--black1);
    display: flex !important;
    width: 100%;
    align-items: center;
    justify-content: space-around;
    height: 56px;
    flex: 0 0 56px;
    padding: 1rem;
  }
  .setup-header-container-mobile div {
    display: flex;
    align-items: center;
    margin-right: 1.5rem;
    cursor: pointer;
    margin-right: 0;
  }
  .setup-header-container-mobile div:last-child {
    margin-right: 0;
  }
  .setup-header-container-mobile span {
    width: 2rem;
    height: 2rem;
    background: var(--black1);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.5s ease;
    cursor: pointer;
    border-radius: 100%;
    margin-right: 0.5rem;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: var(--black5);
    margin-right: 0;
  }
  .setup-header-container-mobile span.active {
    background: var(--purple0);
    color: var(--purple5);
  }
  .setup-header-container-mobile span.checked {
    background: var(--green0);
    color: var(--purple5);
  }
  .setup-header-line {
    display: none;
  }
  .setup-header-logo {
    max-width: 50%;
  }
  .setup-header-logo-image {
    padding-left: 1rem;
  }
  .setup-header-nav {
    max-width: 50%;
    padding-right: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/layouts/setup/header/style.scss"],"names":[],"mappings":"AAEI;EACE,yBAAA;AADN;;AAOA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAJF;AAME;EACE,YAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,gDAAA;AAJJ;AAMI;EACE,wBAAA;AAJN;AASE;EACE,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAPJ;AASI;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;AAPN;AASM;EACE,eAAA;AAPR;AAWI;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AATN;AAWM;EACE,0BAAA;EACA,qBAAA;AATR;AAYM;EACE,yBAAA;EACA,qBAAA;AAVR;AAeE;EACE,YAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,wBAAA;AAbJ;AAeI;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,8BAAA;AAbN;AAeM;EACE,UAAA;EACA,8BAAA;AAbR;AAkBE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,wBAAA;AAhBJ;AAmBE;EACE,aAAA;EACA,mBAAA;EACA,0BAAA;AAjBJ;;AAuBA;EACE;IACE,WAAA;EApBF;EAsBE;IACE,YAAA;EApBJ;EAsBI;IACE,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,cAAA;IACA,gBAAA;EApBN;EAuBI;IACE,mCAAA;IACA,wBAAA;IACA,WAAA;IACA,mBAAA;IACA,6BAAA;IACA,YAAA;IACA,cAAA;IACA,aAAA;EArBN;EAuBM;IACE,aAAA;IACA,mBAAA;IACA,oBAAA;IACA,eAAA;IACA,eAAA;EArBR;EAsBQ;IACE,eAAA;EApBV;EAwBM;IACE,WAAA;IACA,YAAA;IACA,yBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,yBAAA;IACA,eAAA;IACA,mBAAA;IACA,oBAAA;IACA,oBAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,oBAAA;IACA,eAAA;EAtBR;EAwBQ;IACE,0BAAA;IACA,qBAAA;EAtBV;EAyBQ;IACE,yBAAA;IACA,qBAAA;EAvBV;EA8BE;IACE,aAAA;EA5BJ;EA+BE;IACE,cAAA;EA7BJ;EA+BI;IACE,kBAAA;EA7BN;EAiCE;IACE,cAAA;IACA,mBAAA;EA/BJ;AACF","sourcesContent":[".dark .setup-header {\n  &-nav {\n    button.secondary {\n      background: var(--black1);\n    }\n  }\n}\n\n\n.setup-header {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  position: relative;\n  max-width: 1024px;\n  margin: 0 auto;\n\n  &-container {\n    height: 56px;\n    flex: 0 0 56px;\n    border-bottom: 0;\n    width: 100%;\n    z-index: 13;\n    position: relative;\n    background: var(--white);\n    box-shadow: 0 2px 4px -1px rgba(7, 14, 35, 0.08);\n\n    &-mobile {\n      display: none !important;\n    }\n  }\n\n\n  &-line {\n    width: 740px;\n    min-width: 70%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--black5);\n\n    div {\n      display: flex;\n      align-items: center;\n      margin-right: 1.5rem;\n      cursor: pointer;\n\n      &:last-child {\n        margin-right: 0;\n      }\n    }\n\n    span {\n      width: 2rem;\n      height: 2rem;\n      background: var(--black1);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: all .5s ease;\n      cursor: pointer;\n      border-radius: 100%;\n      margin-right: .5rem;\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 17px;\n      color: var(--black5);\n\n      &.active {\n        background: var(--purple0);\n        color: var(--purple5);\n      }\n\n      &.checked {\n        background: var(--green0);\n        color: var(--purple5);\n      }\n    }\n  }\n\n  &-logo {\n    width: calc((1024px - 760px)/2);\n    max-width: 15%;\n    height: 100%;\n    cursor: pointer;\n    background: var(--white);\n\n    &-image {\n      width: 240px;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      padding: 0 0 0 1.5rem;\n      justify-content: space-between;\n\n      &-big {\n        opacity: 1;\n        transition: opacity .15s ease;\n      }\n    }\n  }\n\n  &-nav {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    width: calc((1024px - 760px)/2);\n    max-width: 15%;\n    padding: 0 1.5rem 0 1rem;\n  }\n\n  &-menu {\n    display: flex;\n    align-items: center;\n    transition: all .15s ease;\n  }\n}\n\n\n\n@media (max-width: 768px) {\n  .setup-header {\n    width: 100%;\n\n    &-container {\n      height: auto;\n\n      & > div {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        height: 3.5rem;\n        flex: 0 0 3.5rem;\n      }\n\n      &-mobile {\n        border-top: 1px solid var(--black1);\n        display: flex !important;\n        width: 100%;\n        align-items: center;\n        justify-content: space-around;\n        height: 56px;\n        flex: 0 0 56px;\n        padding: 1rem;\n\n        div {\n          display: flex;\n          align-items: center;\n          margin-right: 1.5rem;\n          cursor: pointer;\n          margin-right: 0;\n          &:last-child {\n            margin-right: 0;\n          }\n        }\n\n        span {\n          width: 2rem;\n          height: 2rem;\n          background: var(--black1);\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          transition: all .5s ease;\n          cursor: pointer;\n          border-radius: 100%;\n          margin-right: .5rem;\n          font-family: 'Inter';\n          font-style: normal;\n          font-weight: 500;\n          font-size: 14px;\n          line-height: 17px;\n          color: var(--black5);\n          margin-right: 0;\n\n          &.active {\n            background: var(--purple0);\n            color: var(--purple5);\n          }\n\n          &.checked {\n            background: var(--green0);\n            color: var(--purple5);\n          }\n        }\n      }\n\n    }\n\n    &-line {\n      display: none;\n    }\n\n    &-logo {\n      max-width: 50%;\n\n      &-image {\n        padding-left: 1rem;\n      }\n    }\n\n    &-nav {\n      max-width: 50%;\n      padding-right: 1rem;\n    }\n\n    &-menu {\n\n    }\n\n  }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
